import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import request from 'superagent';
import swal from 'sweetalert';

import '../node_modules/sweetalert/dist/sweetalert.css';
import './css/font-awesome.css';
import './css/main.css';

import appReducer from './reducers/app-reducer';
import { addBuilds } from './actions/app-actions';
import App from './App';
import Home from './components/home';
import Download from './components/download';
import DownloadClaware from './components/download/claware';
import Contact from './components/contact';

const combinedReducers = combineReducers({
    appState: appReducer,
    routing: routerReducer
});

const store = createStore(combinedReducers);

store.subscribe(() => console.log('state', store.getState()));

// const requestDomain = 'http://localhost:3300';
const requestDomain = '';

request
    .get(`${requestDomain}/api/files`)
    .end((err, res) => {
        if (err) {
            console.error(err);
            // swal('Oops!', err.message, 'error');
            swal('Oops!', 'There was a problem loading the site data. Please try again. If the problem persists, please contact:\n\nhelp@fmosoft.com', 'error');
        } else {
            console.log(res);
            const files = JSON.parse(res.text);
            const clawarePatt = /clawaredvd/i;
            const builds = files
                .filter(f => clawarePatt.test(f.key))
                .map(b => {

                    const v = b.key.match(/\d+/)[0];

                    return {
                        ...b,
                        version: v.slice(0, v.length - 2) + '.' + v.slice(-2)
                    };
                })
                .sort((a, b) => {
                    const aNum = Number(a.version) * 100;
                    const bNum = Number(b.version) * 100;
                    if (aNum === bNum) {
                        return 0;
                    } else if (aNum > bNum) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
            store.dispatch(addBuilds(builds));
        }
    });

const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route path="/" component={App}>
            <IndexRoute component={Home} ></IndexRoute>
            <Route path="download" component={Download}>
                <Route path="claware" component={DownloadClaware}></Route>
            </Route>
            <Route path="contact" component={Contact}></Route></Route>
        </Router>
    </Provider> ,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js